/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CreateWaterPointPollutantDto } from '../models';
import { UpdateWaterPointPollutantDto } from '../models';
import { WaterPointPollutant } from '../models';
import { getFromStorage } from '../../app/helpers';
/**
 * WaterPointPollutantsApi - axios parameter creator
 * @export
 */
export const WaterPointPollutantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateWaterPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterPointPollutantsControllerCreate: async (body: CreateWaterPointPollutantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling waterPointPollutantsControllerCreate.');
            }
            const localVarPath = `/water-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterPointPollutantsControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/water-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterPointPollutantsControllerFindByPointId: async (pointId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointId' is not null or undefined
            if (pointId === null || pointId === undefined) {
                throw new RequiredError('pointId','Required parameter pointId was null or undefined when calling waterPointPollutantsControllerFindByPointId.');
            }
            const localVarPath = `/water-point-pollutants/point/{pointId}`
                .replace(`{${"pointId"}}`, encodeURIComponent(String(pointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterPointPollutantsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling waterPointPollutantsControllerFindOne.');
            }
            const localVarPath = `/water-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterPointPollutantsControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling waterPointPollutantsControllerRemove.');
            }
            const localVarPath = `/water-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateWaterPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterPointPollutantsControllerUpdate: async (body: UpdateWaterPointPollutantDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling waterPointPollutantsControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling waterPointPollutantsControllerUpdate.');
            }
            const localVarPath = `/water-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterPointPollutantsApi - functional programming interface
 * @export
 */
export const WaterPointPollutantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateWaterPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerCreate(body: CreateWaterPointPollutantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<WaterPointPollutant>>> {
            const localVarAxiosArgs = await WaterPointPollutantsApiAxiosParamCreator(configuration).waterPointPollutantsControllerCreate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<WaterPointPollutant>>>> {
            const localVarAxiosArgs = await WaterPointPollutantsApiAxiosParamCreator(configuration).waterPointPollutantsControllerFindAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<WaterPointPollutant>>>> {
            const localVarAxiosArgs = await WaterPointPollutantsApiAxiosParamCreator(configuration).waterPointPollutantsControllerFindByPointId(pointId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<WaterPointPollutant>>> {
            const localVarAxiosArgs = await WaterPointPollutantsApiAxiosParamCreator(configuration).waterPointPollutantsControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<WaterPointPollutant>>> {
            const localVarAxiosArgs = await WaterPointPollutantsApiAxiosParamCreator(configuration).waterPointPollutantsControllerRemove(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UpdateWaterPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerUpdate(body: UpdateWaterPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<WaterPointPollutant>>> {
            const localVarAxiosArgs = await WaterPointPollutantsApiAxiosParamCreator(configuration).waterPointPollutantsControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WaterPointPollutantsApi - factory interface
 * @export
 */
export const WaterPointPollutantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {CreateWaterPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerCreate(body: CreateWaterPointPollutantDto, options?: AxiosRequestConfig): Promise<AxiosResponse<WaterPointPollutant>> {
            return WaterPointPollutantsApiFp(configuration).waterPointPollutantsControllerCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<WaterPointPollutant>>> {
            return WaterPointPollutantsApiFp(configuration).waterPointPollutantsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<WaterPointPollutant>>> {
            return WaterPointPollutantsApiFp(configuration).waterPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<WaterPointPollutant>> {
            return WaterPointPollutantsApiFp(configuration).waterPointPollutantsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<WaterPointPollutant>> {
            return WaterPointPollutantsApiFp(configuration).waterPointPollutantsControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateWaterPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterPointPollutantsControllerUpdate(body: UpdateWaterPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<WaterPointPollutant>> {
            return WaterPointPollutantsApiFp(configuration).waterPointPollutantsControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterPointPollutantsApi - object-oriented interface
 * @export
 * @class WaterPointPollutantsApi
 * @extends {BaseAPI}
 */
export class WaterPointPollutantsApi extends BaseAPI {
    /**
     * 
     * @param {CreateWaterPointPollutantDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterPointPollutantsApi
     */
    public async waterPointPollutantsControllerCreate(body: CreateWaterPointPollutantDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<WaterPointPollutant>> {
        return WaterPointPollutantsApiFp(this.configuration).waterPointPollutantsControllerCreate(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterPointPollutantsApi
     */
    public async waterPointPollutantsControllerFindAll(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<WaterPointPollutant>>> {
        return WaterPointPollutantsApiFp(this.configuration).waterPointPollutantsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} pointId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterPointPollutantsApi
     */
    public async waterPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<WaterPointPollutant>>> {
        return WaterPointPollutantsApiFp(this.configuration).waterPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterPointPollutantsApi
     */
    public async waterPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<WaterPointPollutant>> {
        return WaterPointPollutantsApiFp(this.configuration).waterPointPollutantsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterPointPollutantsApi
     */
    public async waterPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<WaterPointPollutant>> {
        return WaterPointPollutantsApiFp(this.configuration).waterPointPollutantsControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {UpdateWaterPointPollutantDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterPointPollutantsApi
     */
    public async waterPointPollutantsControllerUpdate(body: UpdateWaterPointPollutantDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<WaterPointPollutant>> {
        return WaterPointPollutantsApiFp(this.configuration).waterPointPollutantsControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
